import { takeEvery, call, put } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { tourDetailsRequest, tourDetailsSuccess, tourDetailsFail } from '../../slices/tour';

const queryString = require('query-string');

function* tourDetailsWorker({ payload: { productId } }) {
  try {
    const url = `/tours/details?${queryString.stringify({ productId }, { skipNull: true })}`;

    const { data } = yield call(axios, { method: 'get', url });
    yield put(tourDetailsSuccess({ productId, response: data }));
  } catch (error) {
    yield put(tourDetailsFail({ productId, error: `${error}` }));
  }
}

function* tourDetailsWatcher() {
  yield takeEvery(tourDetailsRequest.toString(), tourDetailsWorker);
}

export default tourDetailsWatcher;
